import type { TravelerState } from '@/types'
import type { ChildrenAges } from '@pcln/traveler-selection'
import * as yup from 'yup'
import { BUNDLE_MAX_CAPACITY_ERROR, CHILD_AGE_REQUIRED, INVALID_DATE, LOCATION_REQUIRED } from '../validation'

const MAXIMUM_BUNDLE_GUEST_COUNT = 8

function numOfValidAges(childrenAges: ChildrenAges) {
  if (typeof childrenAges === 'object' && childrenAges !== null) {
    return Object.values(childrenAges).filter((age) => {
      const num = parseInt(age, 10)
      return !Number.isNaN(num) && num >= 0
    })
  }
  return []
}

function isChildrenAgeNotProvided(children: number, childrenAges: ChildrenAges) {
  return children > 0 && children !== numOfValidAges(childrenAges).length
}

export function handleChildrenAges(this: yup.TestContext) {
  const { children, childrenAges } = this.parent as TravelerState
  if (isChildrenAgeNotProvided(children, childrenAges)) {
    return this.createError({
      message: CHILD_AGE_REQUIRED,
      path: this.path,
    })
  }
  return true
}

export function handleRoomCapacity(this: yup.TestContext) {
  const { adults, children } = this.parent as TravelerState
  const travelerCount = adults + children
  const allowedTravelerCount = MAXIMUM_BUNDLE_GUEST_COUNT

  if (allowedTravelerCount < travelerCount) {
    return this.createError({
      message: BUNDLE_MAX_CAPACITY_ERROR,
      path: this.path,
    })
  }

  return true
}

export const searchFormSchema = yup.object().shape({
  hotels: yup.array().of(
    yup.object().shape({
      endLocation: yup.object().nullable().required(LOCATION_REQUIRED),
      startDate: yup.string().nullable().required(INVALID_DATE),
      endDate: yup.string().nullable().required(INVALID_DATE),
    }),
  ),
  travelers: yup.object().shape({
    children: yup.number().test({
      name: 'children',
      test: handleChildrenAges,
    }),
    rooms: yup.number().test({
      name: 'rooms',
      test: handleRoomCapacity,
    }),
  }),
})
